var _path, _path2, _path3, _path4, _g, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.252 27.494a5.512 5.512 0 01-5.505-5.505H17.76a5.512 5.512 0 01-5.507 5.505z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.252 25.995a4.013 4.013 0 003.715-2.507h-7.43a4.013 4.013 0 003.715 2.506m0 1.5a5.512 5.512 0 01-5.506-5.506H17.76a5.512 5.512 0 01-5.507 5.506z",
    fill: "#FFF",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.411 16.204H5.382v-5.2a7.02 7.02 0 017.013-7.013 7.021 7.021 0 017.014 7.013v5.2h.002z",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.411 16.205v-5.202a7.02 7.02 0 00-7.013-7.013 7.02 7.02 0 00-7.013 7.013v5.199h13.897c.043 0 .086 0 .128.002h.001m0 1.5h-.056a1.976 1.976 0 00-.073-.002H3.885v-6.7c0-4.693 3.82-8.512 8.513-8.512 4.694 0 8.513 3.819 8.513 8.513v6.7l-1.5.001z",
    fill: "#00B8F1",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.404 16.201h15.793a3.644 3.644 0 013.644 3.644c0 2.013.315 3.644-1.7 3.644H2.521C.506 23.49.76 21.858.76 19.845a3.644 3.644 0 013.643-3.644z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.405 17.701a2.147 2.147 0 00-2.145 2.144c0 .218-.003.427-.005.629-.007.49-.016 1.201.06 1.504a1.5 1.5 0 00.205.012h19.624c.071 0 .127-.003.17-.008.06-.301.046-.94.037-1.382-.004-.242-.01-.492-.01-.755a2.147 2.147 0 00-2.144-2.144H4.405m0-1.5h15.793a3.644 3.644 0 013.645 3.644c0 2.013.315 3.645-1.698 3.645H2.52c-2.013 0-1.76-1.632-1.76-3.645a3.644 3.644 0 013.644-3.644h.001z",
    fill: "#00B8F1",
    fillRule: "evenodd"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.45 2.99V.75",
    fill: "none",
    stroke: "#00B8F1",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

export default SvgIconBell;